import TableSkeleton from '../../../components/loaders/TableSkeleton';
import ListHeader from '../../../components/ListHeader';
import { useTranslation } from 'react-i18next';
import useModuleTableHelpers from '../../../hooks/useModuleTableHelpers';
import Button from '../../../components/buttons/Button';
import TermsAndConditionsTable from '../../../modules/termsAndConditions/components/TermsAndConditionsTable';

const TermsAndConditions = () => {
  const { t } = useTranslation();

  const { apiData, apiDataLoading, paginationEle } = useModuleTableHelpers({
    route: 'admin/cms/terms-and-conditions',
    withBreadcrumb: true,
    breadcrumbTitle: t('terms-and-conditions'),
    withPagination: true,
    queryKey: 'terms-and-conditions'
  });

  const tableHeaders = [
    { label: t('type') },
    { label: t('actions'), customClass: 'actions_col' }
  ];

  if (apiDataLoading) return <TableSkeleton columns={6} withoutButton />;

  return (
    <div className="fuelTypes-page-container">
      <ListHeader customClass='table_filters'>
         <Button text={t('create_terms_and_conditions')} link="/terms-and-conditions/create-terms-and-conditions" />
      </ListHeader>
      <TermsAndConditionsTable tableHeaders={tableHeaders} data={apiData} noDataMessage={t('no_terms_and_conditions_found')} lessColumns />
      {paginationEle}
    </div>
  );
};

export default TermsAndConditions;
